import { Pipe, PipeTransform } from '@angular/core';
import { EmailStatus } from '@workspace/data-types';
import { CoreNiceLabelUtils } from '../core-nice-label.utils';

@Pipe({
  name: 'emailStatusDisplay',
})
export class EmailStatusDisplayPipe implements PipeTransform {
  transform(value: EmailStatus): string {
    return emailStatusDisplayTransform(value);
  }
}

export function emailStatusDisplayTransform(value: EmailStatus) {
  return CoreNiceLabelUtils.emailStatus(value);
}
